/* --------------------------------------------------------------------------
  Add-to-Bag Popup & Cart Helpers
  Loaded globally so quickshop + product-form can both use them.
--------------------------------------------------------------------------- */

window.formatMoneySafe = (cents) => {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, window.shopifyMoneyFormat || '${{amount}}');
  }
  return '$' + (cents / 100).toFixed(2);
};

window.updateCartCount = async () => {
  try {
    const cart = await fetch('/cart.js').then((r) => r.json());

    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    if (cart.item_count > 0) {
      bubble.classList.remove('hidden');
      bubble.querySelector('[aria-hidden="true"]').textContent = cart.item_count;
      bubble.querySelector('.visually-hidden').textContent =
        `${cart.item_count} items`;
    } else {
      bubble.classList.add('hidden');
    }
  } catch (e) {}
};

window.updatePopupRelatedCards = (popup, targetColor, excludeHandle = '') => {
  const gridItems = popup.querySelectorAll('.popup-grid__item');
  const popupRelated = popup.querySelector('.popup-related');
  let shown = 0;

  gridItems.forEach((el) => {
    const handle = el.dataset.productHandle || '';
    const productColors = (el.dataset.productColors || '').toLowerCase();

    if (handle === excludeHandle) {
      el.style.display = 'none';
      return;
    }

    const hasMatchingColor = targetColor && productColors.includes(targetColor + '|||');

    if (hasMatchingColor && shown < 3) {
      el.style.display = '';
      shown++;

      const cardWrapper = el.querySelector('.card-wrapper');
      if (cardWrapper) {
        const allSwatchItems = el.querySelectorAll('.card-swatches__item');
        allSwatchItems.forEach((swatchItem) => {
          const swatch = swatchItem.querySelector('.card-swatches__swatch');
          if (swatch && swatch.dataset.color && swatch.dataset.color.toLowerCase() === targetColor) {
            allSwatchItems.forEach((si) => si.classList.remove('is-active'));
            swatchItem.classList.add('is-active');
          }
        });

        try {
          const imageMap = JSON.parse(cardWrapper.dataset.variantImages || '{}');
          const variantMap = JSON.parse(cardWrapper.dataset.variantIds || '{}');
          const videoMap = JSON.parse(cardWrapper.dataset.variantVideos || '{}');

          const cardImg = cardWrapper.querySelector('.card-main-image');
          const video = cardWrapper.querySelector('.card-faceout-video');
          const videoSrc = videoMap[targetColor];

          if (videoSrc && video) {
            video.src = videoSrc;
            video.classList.remove('hidden');
            if (cardImg) cardImg.classList.add('hidden');
          } else {
            const nextSrc = imageMap[targetColor] || cardWrapper.dataset.defaultImage;
            if (video) {
              video.removeAttribute('src');
              video.classList.add('hidden');
            }
            if (cardImg) {
              cardImg.classList.remove('hidden');
              if (nextSrc) {
                cardImg.src = nextSrc;
                cardImg.srcset = nextSrc;
              }
            }
          }

          const matchingVariantId = variantMap[targetColor];
          if (matchingVariantId) {
            cardWrapper.querySelectorAll('a[href]').forEach((link) => {
              const url = new URL(link.href);
              url.searchParams.set('variant', matchingVariantId);
              link.href = url.toString();
            });
          }

          const colorBar = cardWrapper.querySelector('.card-color-bar');
          if (colorBar && cardWrapper.dataset.colorInfo) {
            const colorInfoMap = JSON.parse(cardWrapper.dataset.colorInfo || '{}');
            const colorInfo = colorInfoMap[targetColor];
            if (colorInfo) {
              colorBar.style.backgroundColor = colorInfo.color;
              colorBar.style.setProperty('--color-bar-bg', colorInfo.color);
              const nameEl = colorBar.querySelector('.card-color-bar__name');
              if (nameEl) {
                nameEl.textContent = colorInfo.name;
              }
            }
          }
        } catch (err) {}
      }
    } else {
      el.style.display = 'none';
    }
  });

  if (popupRelated) {
    popupRelated.style.display = shown > 0 ? '' : 'none';
  }
};

window.showAddToBagPopupFromVariant = async (variantId, preSelectedColor = '', inventoryData = null) => {
  const popup = document.getElementById('AddToBagPopup');
  if (!popup) return;

  const img = popup.querySelector('.add-to-bag-popup__image img');
  const titleEl = popup.querySelector('.add-to-bag-popup__title');
  const optionsEl = popup.querySelector('.add-to-bag-popup__options');
  const subtotalEl = popup.querySelector('.add-to-bag-popup__subtotal-price');
  const closeBtn = popup.querySelector('.add-to-bag-popup__close');
  const viewCartBtn = popup.querySelector('.add-to-bag-popup__view-cart');

  const closePopup = () => {
    popup.setAttribute('hidden', true);
    document.body.style.overflow = '';
  };
  closeBtn.onclick = closePopup;
  viewCartBtn.onclick = () => {
    closePopup();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      const drawerItems = drawer.querySelector('cart-drawer-items');
      if (drawerItems) drawerItems.classList.remove('is-empty');
      fetch(routes.cart_url + '?section_id=cart-drawer')
        .then((r) => r.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newContent = parsed.querySelector('#CartDrawer');
          const target = document.getElementById('CartDrawer');
          if (newContent && target) target.innerHTML = newContent.innerHTML;
          drawer.open();
        })
        .catch(() => drawer.open());
    }
  };
  popup.onclick = (e) => {
    if (e.target === popup) closePopup();
  };

  if (preSelectedColor) {
    updatePopupRelatedCards(popup, preSelectedColor);
  }

  try {
    const cart = await fetch('/cart.js').then((r) => r.json());

    const item = cart.items.find((i) => i.variant_id === Number(variantId));
    if (!item) return;

    img.src = item.image;
    img.alt = item.product_title;

    const preorderEl = popup.querySelector('.add-to-bag-popup__preorder');
    const isPreOrder = /pre[- ]?order/i.test(item.product_title);
    const preorderWeeks = (item.properties && item.properties['_preorder_weeks']) || '16';
    let displayTitle = item.product_title.replace(/\s*\|?\s*Pre[- ]?Order/i, '').trim();

    if (isPreOrder && preorderEl) {
      preorderEl.removeAttribute('hidden');
      const weeksText = preorderWeeks === '1' ? '1 week' : `${preorderWeeks} weeks`;
      preorderEl.innerHTML = `<b>Pre-Order:</b> Estimated to ship in ${weeksText}.`;
    } else if (preorderEl) {
      preorderEl.setAttribute('hidden', true);
    }
    titleEl.textContent = displayTitle;

    optionsEl.innerHTML = '';
    item.options_with_values.forEach((opt) => {
      const li = document.createElement('li');
      li.textContent = `${opt.name}: ${opt.value}`;
      optionsEl.appendChild(li);
    });

    subtotalEl.textContent = formatMoneySafe(cart.items_subtotal_price);

    if (!preSelectedColor) {
      let addedColor = '';
      if (item.options_with_values) {
        const colorOption = item.options_with_values.find(opt => opt.name === 'Color');
        if (colorOption) {
          addedColor = colorOption.value.toLowerCase().trim();
        }
      }
      if (addedColor) {
        updatePopupRelatedCards(popup, addedColor, item.handle || '');
      }
    } else {
      updatePopupRelatedCards(popup, preSelectedColor, item.handle || '');
    }

    popup.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  } catch (e) {}
};
